module.exports = __webpack_public_path__ + "h5/img/index_new.595cf4a4.png";